import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.47 13.297a.79.79 0 0 0 0 1.107.807.807 0 0 0 1.116 0L8.21 8.78l5.625 5.625c.299.3.817.308 1.116 0a.796.796 0 0 0 0-1.107L9.327 7.663l5.625-5.625a.79.79 0 0 0 0-1.107.79.79 0 0 0-1.116 0L8.21 6.556 2.586.93a.783.783 0 0 0-1.116 0 .796.796 0 0 0 0 1.107l5.625 5.625-5.625 5.634Z" }, null, -1)
  ]))]))
}
export default { render: render }